import { render } from "./knowledge-library.vue?vue&type=template&id=1194e3f5"
import script from "./knowledge-library.vue?vue&type=script&lang=js"
export * from "./knowledge-library.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__